import { HttpContextToken } from '@angular/common/http';

export const BYPASS_UNWRAP = new HttpContextToken<boolean>(() => false);
